import { s3AdapterApi } from "../../api";
import { ModernApi } from "../../api/project/types";

export const getProjectImage = async (
  params: ModernApi.GetProjectImageRequest,
): Promise<ModernApi.GetProjectImageResponse> => {
  const response = await s3AdapterApi.get(`/files/${params.fileId}`, {
    params: {
      type: params.type,
    },
  });
  return response.data;
};
